// extracted by mini-css-extract-plugin
var _1 = "howSendItSelector_check__FAtfI";
var _2 = "howSendItSelector_checkContainer__Wrf8E";
var _3 = "howSendItSelector_container__dDdut";
export { _1 as "check", _2 as "checkContainer", _3 as "container" }
